import React, { useEffect } from 'react';
import Blank from './sections/Blank';
import Footer from './sections/Footer';
import GetStarted from './sections/GetStarted';
import Header from './sections/Header';
import HeroSection from './sections/HeroSection';
import HowItWorks from './sections/HowItWorks';
import Newsletter from './sections/Newsletter';
import Testimonials from './sections/Testimonials';
import WhatWeDo from './sections/WhatWeDo';
import { Helmet } from 'react-helmet-async';
import AnnHeroSection from './sections/AnnHeroSection';
// import LoanGuide from './sections/LoanGuide';

const Home = () => {
  //Search for the refCode in the URL and save it to local storage if it exists
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');

    if (refCode) {
      const currentTime = new Date().getTime();
      localStorage.setItem('referredByCode', refCode);
      localStorage.setItem('refCodeTimestamp', currentTime.toString());
    }

    // Check if 30 days have passed since the refCode was stored
    const storedTimestamp = localStorage.getItem('refCodeTimestamp');
    if (storedTimestamp) {
      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000;
      const currentTime = new Date().getTime();

      if (
        currentTime - parseInt(storedTimestamp, 10) >
        thirtyDaysInMilliseconds
      ) {
        localStorage.removeItem('referredByCode');
        localStorage.removeItem('refCodeTimestamp');
      }
    }
  }, []);
  return (
    <div className="bg-white">
      <Helmet>
        {/* <title>Home | Trade Lenda Landing Page!</title> */}
        <title>Trade Lenda - Digital Banking Solutions for SMEs</title>
        <link rel="canonical" href={window.location.href} />
        <meta
          name="description"
          content="Discover Trade Lenda, a digital bank for SMEs offering innovative solutions including bill payment, loans, insurance, and investment services to grow your business."
        />
        <meta
          name="keywords"
          content="Digital bank, SME banking, loans for businesses, investment services, bill payment, insurance for SMEs"
        />
      </Helmet>
      <Header />
      {/* <HeroSection /> */}
      <AnnHeroSection />
      <WhatWeDo />
      <HowItWorks />
      {/* <LoanGuide /> */}
      <Testimonials />
      <Blank height="40px" />
      <GetStarted />
      <Blank height="40px" />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Home;
